import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["placeholder"]

  connect() {
    this.placeholders = document.querySelectorAll('.youtube-placeholder')
    this.placeholders.forEach(placeholder => {
      placeholder.addEventListener('click', this.loadVideo.bind(this))
      placeholder.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          this.loadVideo({ currentTarget: placeholder })
        }
      })
    })
  }

  loadVideo(event) {
    const placeholder = event.currentTarget
    const youtubeId = placeholder.dataset.youtubeId

    // Cria o iframe do YouTube
    const iframe = document.createElement('iframe')
    iframe.setAttribute('src', `https://www.youtube.com/embed/${youtubeId}?autoplay=1`)
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
    iframe.setAttribute('allowfullscreen', '')
    iframe.style.width = '100%'
    iframe.style.height = '100%'
    iframe.style.position = 'absolute'
    iframe.style.top = '0'
    iframe.style.left = '0'

    // Substitui o placeholder pelo iframe
    placeholder.innerHTML = ''
    placeholder.appendChild(iframe)
  }
}